import type { HTMLProps } from 'react';
import { useSymbolStore } from '@/stores/symbol';
import Selector from '../common/selector';
import type { SelectorItem } from './symbol.type';

type Props<T> = {
  className?: string;
  categories: SelectorItem[];
  itemProps?: HTMLProps<HTMLElement> & T;
};

export default function CategorySelector<T>({ className, categories = [], itemProps }: Props<T>) {
  const scrollRefs = useSymbolStore((s) => s.scrollRefs);
  const selectedCategory = useSymbolStore((s) => s.selectedCategory);
  const setSelectedCategory = useSymbolStore((s) => s.setSelectedCategory);

  const select = (slug: string) => {
    const ref = scrollRefs[slug];

    if (ref && ref.parentElement) {
      ref.parentElement.scrollTop = ref.offsetTop - ref.parentElement.offsetTop;
    }

    setSelectedCategory(slug);
  };

  return (
    <Selector<T>
      className={className}
      items={categories}
      itemProps={itemProps}
      selected={selectedCategory}
      onSelect={(slug) => select(slug)}
    />
  );
}
